// Calculate Percentages based on aggregate score and possible scores
export const calculatePercentage = (aggregateScore, possibleScore) => {
  if (!aggregateScore || !possibleScore) return '0'
  const num = (aggregateScore / possibleScore) * 100
  return num.toFixed(2)
}
